import { makeStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput";
import { useParams } from "react-router-dom";
import { formatCurrency } from "functions/Helper";
import { formatDateTime } from "functions/Helper";
import { orderApi } from "functions/apis";

const useStyles = makeStyles(styles);

const statusList = ["Pending", "Waiting For Payment", "Paid", "Cancelled"];

const ViewOnlineOrder = props => {
  const classes = useStyles();

  const [input, setInput] = useState(null);

  const { id } = useParams();

  const viewOnlineOrderSignal = useRef(new AbortController());

  useEffect(() => {
    orderApi
      .get("OnlineOrders/" + id, {
        signal: viewOnlineOrderSignal.current.signal
      })
      .then(resp => {
        setInput(resp);
      });
    return () => viewOnlineOrderSignal.current.abort();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>VIEW ONLINE ORDER</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            {input != null && (
              <form>
                <GridContainer>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Booking No"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: input.no,
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Voucher Type"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: input.voucherType ? input.voucherType.name : "-",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Status"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: statusList[input.status],
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Transaction Time"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: formatDateTime(
                          new Date(input.transactionTime + "Z")
                        ),
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Customer Name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: input.user ? input.user.name : "-",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Customer Email"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: input.user ? input.user.email : "-",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Unit Price"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: input.currency
                          ? formatCurrency(input.currency.code, input.unitPrice)
                          : "XXX",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Quantity"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: input.quantity,
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText="Total"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value:
                          input == null
                            ? ""
                            : formatCurrency(
                                input.currency === null
                                  ? "XXX"
                                  : input.currency.code,
                                input.total
                              ),
                        disabled: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </form>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default ViewOnlineOrder;

ViewOnlineOrder.propTypes = {
  history: PropTypes.object
};
